"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// 滑块的宽度，高度 = 宽度 * 2
var const_1 = require("../../../const");
exports.SLIDER_WIDTH = 8;
exports.SLIDER_HEIGHT = exports.SLIDER_WIDTH * 2;
exports.SLIDER_CIRCLE_MAX_SIZE = exports.SLIDER_HEIGHT * 2;
exports.TEXT_OFFSET = 4;
exports.SliderBtnStyle = {
    fill: '#fff',
    // shadowOffsetX: -2,
    // shadowOffsetY: 2,
    shadowBlur: 10,
    shadowColor: 'rgba(0,0,0,0.65)',
    radius: 2,
};
exports.SliderTextStyle = {
    fill: '#333',
    textAlign: 'center',
    textBaseline: 'middle',
    stroke: '#fff',
    lineWidth: 5,
    fontFamily: const_1.FONT_FAMILY,
};
exports.SliderMiddleBackgroundStyle = {
    fill: '#D9D9D9',
};
exports.SliderMiddleFrontendStyle = {
    fill: 'rgb(64, 141, 251)',
};
exports.DefaultTitleStyle = {
    fill: '#333',
    textBaseline: 'top',
    textAlign: 'start',
    fontFamily: const_1.FONT_FAMILY,
};
//# sourceMappingURL=index.js.map